import React from "react";
import { RichText } from "prismic-reactjs";

export default class ImageWithText extends React.Component {
  render() {
    const { data, prismicCtx } = this.props;

    return (
      <div className="slices-items">
        {data.items.map((item, index) => {
          return (
            <div className="row mb-3" key={index}>
              <div className="col-xs-6 col-sm-3">
                <img src={item.image.url} className="img-fluid" alt="" />
              </div>
              <div className="col-xs-6 col-sm-9">
                <div className="item-text">
                  {RichText.render(item.text, prismicCtx.linkResolver)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/slices/ImageWithText.js